module.exports = __webpack_public_path__ + "static/img/mine_tit.0829a93f.png";